import React from 'react';
import '../Language.css';
function GenresScreen() {
    return (
        <div className="main-container">

        <h2>Genres</h2>
        <div className="image-container">

       
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language">
           <div className="mid-container">
            
            <span>COMEDY</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
     
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/LANGUAGE/5708/5708/5708-h')` }}>
           <div className="mid-container">
            
            <span>ROMANCE</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/926/926/926-h')`}}>
           <div className="mid-container">
            
            <span>DRAMA</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/924/924/924-h')`}}>
           <div className="mid-container">
            
            <span>MYTHOLOGY</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/6787/6787/6787-h')`}}>
           <div className="mid-container">
           
            <span>ACTION</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/4992/14992/14992-h')`}}>
           <div className="mid-container">
           
            <span>BIOPIC</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/6552/6552/6552-h')`}}>
           <div className="mid-container">
           
            <span>TRAVEL</span>
            </div>
        </div>
     </div>

     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/835/670835-h')`}}>
           <div className="mid-container">
           
            <span>SUPERHERO</span>
            </div>
        </div>
     </div>

     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/926/926/926-h')`}}>
           <div className="mid-container">
            
            <span>DRAMA</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/924/924/924-h')`}}>
           <div className="mid-container">
            
            <span>MYTHOLOGY</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/6787/6787/6787-h')`}}>
           <div className="mid-container">
           
            <span>ACTION</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/4992/14992/14992-h')`}}>
           <div className="mid-container">
           
            <span>BIOPIC</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/6552/6552/6552-h')`}}>
           <div className="mid-container">
           
            <span>TRAVEL</span>
            </div>
        </div>
     </div>

     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/835/670835-h')`}}>
           <div className="mid-container">
           
            <span>SUPERHERO</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/926/926/926-h')`}}>
           <div className="mid-container">
            
            <span>DRAMA</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/924/924/924-h')`}}>
           <div className="mid-container">
            
            <span>MYTHOLOGY</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/6787/6787/6787-h')`}}>
           <div className="mid-container">
           
            <span>ACTION</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/4992/14992/14992-h')`}}>
           <div className="mid-container">
           
            <span>BIOPIC</span>
            </div>
        </div>
     </div>
     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/old_images/GENRE/6552/6552/6552-h')`}}>
           <div className="mid-container">
           
            <span>TRAVEL</span>
            </div>
        </div>
     </div>

     <div className="whole-card">
      <div className="gray-card"></div>
        <div className="language" style={{ backgroundImage : `url('https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/835/670835-h')`}}>
           <div className="mid-container">
           
            <span>SUPERHERO</span>
            </div>
        </div>
     </div>
        
    

        </div>
    </div>
    )
}

export default GenresScreen
